import React, { useState, useEffect } from "react";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { ListDialog } from "../shared/listDialog";
import { preauthorizationService } from '../../services/api/preauthorization.service';
import { alertService } from '../../services/helpers/alert.service';



export const PreauthorizationInvestigations = (props) => {

    const _newRow = {
        idInvestigatie: 0,
        idPreautorizare: props.id ?? 0,
    }

    const [list, setList] = useState([]);
    const [dropdown, setDropdown] = useState([])
    const [defaults, setDefaults] = useState([])
    const [showDialog, setShowDialog] = useState(false);
    const [clickedIndex, setClickedIndex] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");


    const [newRow, setNewRow] = useState(_newRow);

    useEffect(() => {
        if (props && props.id) {
            preauthorizationService.getInvestigations({ preauthorizationId: props.id })
                .then(response => {
                    if (response) {
                        setList(response);
                        props.setInvestigatii(response);
                    }
                });
        }
    }, [props.refresh]);

    useEffect(() => {

        if (props.pacient && props.partener && props.abonament) {

            preauthorizationService.getInvestigationsDropDown({
                pacient: props.pacient,
                partener: props.partener,
                abonament: props.abonament,
                data: props.data,
                preautorizare: props.id,
            })
                .then(response => {
                    if (response) {
                        if (Array.isArray(response) && response.length > 0) {
                            for (let i = 0; i < response.length; i++) {
                                response[i].id = response[i].investigatie;
                                response[i].text = response[i].denumire;
                            }
                        }

                        setDropdown(response);
                    }
                    else {
                        setDropdown([]);
                    }

                    if (list.length > 0 && response.length > 0) {
                        var d = [];
                        for (var item in list) {
                            var el = response.find(obj => obj.investigatie === list[item].idInvestigatie)
                            if (el) {
                                d.push(el);
                            }
                        }
                        setDefaults(d);
                    }
                });
        }
    }, [props.pacient, props.partener, props.abonament]);

    const updateLists = (list) => {
        setList(list);
        props.setInvestigatii(list);
        if (props.setIsModified) {
            props.setIsModified(true);
        }
    }


    const handleAdd = () => {
        const updatedList = [...list, newRow];
        updateLists(updatedList);
        setNewRow(_newRow);
    };

    const handleChange = (event, index, field) => {
        const updatedList = [...list];
        var v = event.target.value;
        updatedList[index][field] = v.id;
        updateLists(updatedList);
        setSearchTerm("");
    };

    const handleDelete = (index) => {

        alertService.confirm("Atentie", "Esti sigur ca vrei sa stergi aceasta investigatie?"
            , () => {
                const updatedList = [...list];
                updatedList.splice(index, 1);
                updateLists(updatedList);
            }
            , () => { return; }
        );


    };

    /* Butonul de editare */
    const handleDialog = () => {
        setShowDialog(!showDialog);
    }

    const handleClick = (item) => {
        setClickedIndex(item);
        setShowDialog(true);
    }

    const handleReturn = (item) => {

        let newList = [...list];
        newList[clickedIndex].idInvestigatie = dropdown[item].id;
        updateLists(newList);

    }

    const handleFilterChange = (e) => {
        setSearchTerm(e.filter.value);
    };

    const filtred = searchTerm
        ? dropdown.filter((item) =>
            item.text.toLowerCase().includes(searchTerm.toLowerCase())
        )
        : dropdown;



    return (
        <>
            <label className="pt10 pb5">Investigatii: <span className="red">*</span></label>
            <table className="tbl tbladd" name="lista_investigatii" width="100%">
                <thead>
                    <tr>
                        <th>Nume investigatie</th>
                        <th width="30"></th>
                        <th width="30"></th>
                    </tr>
                </thead>
                <tbody>
                    {list.map((item, index) => (
                        <tr key={index}>
                            <td name="investigatie">
                                <DropDownList className="w260 fl"
                                    data={filtred}
                                    textField="text"
                                    dataItemKey="id"
                                    value={defaults[index]}
                                    name="idInvestigatie"
                                    onChange={(event) => handleChange(event, index, "idInvestigatie")}
                                    disabled={props.finalizare == 1}
                                    onFilterChange={handleFilterChange}
                                    filterable
                                />
                            </td>
                            {!props.finalizare && (
                                <>
                                    <td name="investigatie_edit"
                                        onClick={() => handleClick(index)}>
                                        <span className="icon modifica center"></span>
                                    </td>
                                    <td name="investigatie_del"
                                        onClick={() => handleDelete(index)}>
                                        <span className="icon sterge center"></span>
                                    </td>
                                </>
                            )}
                        </tr>
                    ))}
                </tbody>
            </table>
            {props.finalizare != 1 && < button
                    name="adauga_investigatie"
                    className="btn"
                    onClick={handleAdd} >Adauga investigatie</button>
            }
            {
                showDialog  && < ListDialog title="Investigatii"
                    data={dropdown}
                    handleDialog={handleDialog}
                    handleReturn={handleReturn} />
            }

        </>
    
    );
}
